import { ChevronLeft, ChevronRight, Leaf } from "lucide-react";
import { NavLink } from "react-router-dom";
import { navigationItems } from "../app/navigation";
import { cx } from "../utils/cx";

function SidebarLink({ item, isCollapsed, onNavigate }) {
  const Icon = item.icon;

  return (
    <NavLink
      end={item.path === "/"}
      to={item.path}
      aria-label={isCollapsed ? item.label : undefined}
      title={isCollapsed ? item.label : undefined}
      className={({ isActive }) =>
        cx("sidebar-link", isCollapsed && "is-collapsed", isActive && "is-active")
      }
      onClick={onNavigate}
    >
      <Icon className="sidebar-link-icon" />
      <span className="sidebar-link-label">{item.label}</span>
    </NavLink>
  );
}

function Sidebar({
  isDesktopViewport,
  isExpanded,
  isOpen,
  onClose,
  onNavigate,
  onToggle,
}) {
  const isCollapsed = isDesktopViewport && !isExpanded;
  const toggleLabel = isDesktopViewport
    ? isCollapsed
      ? "Expand sidebar"
      : "Collapse sidebar"
    : "Close navigation";
  const ToggleIcon = isCollapsed ? ChevronRight : ChevronLeft;

  return (
    <>
      <button
        aria-label="Close navigation"
        className={cx(
          "sidebar-scrim",
          !isDesktopViewport && isOpen && "is-visible"
        )}
        type="button"
        onClick={onClose}
      />

      <aside
        id="admin-sidebar"
        className={cx(
          "sidebar",
          isDesktopViewport && "is-desktop",
          isOpen && "is-open",
          isCollapsed && "is-collapsed"
        )}
      >
        <div className="sidebar-header">
          <div className="brand-lockup">
            <div className="brand-mark">
              <Leaf size={18} />
            </div>
            <div className="brand-copy">
              <p className="brand-title">GrozyKart</p>
              <p className="brand-subtitle">Admin</p>
            </div>
          </div>

          <button
            aria-label={toggleLabel}
            aria-controls="admin-sidebar"
            aria-expanded={!isCollapsed}
            className="icon-button sidebar-toggle-button"
            type="button"
            onClick={onToggle}
          >
            <ToggleIcon size={16} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navigationItems.filter((item) => !item.hidden).map((item) => (
            <SidebarLink
              key={item.path}
              item={item}
              isCollapsed={isCollapsed}
              onNavigate={onNavigate}
            />
          ))}
        </nav>

        <div className="sidebar-footer">
          <p className="sidebar-footer-copy">Catalog, orders, customers and settings.</p>
        </div>
      </aside>
    </>
  );
}

export default Sidebar;
